import { Button } from '@progress/kendo-react-buttons'
import { StackLayout } from '@progress/kendo-react-layout'
import { FC, MouseEvent } from 'react'
import { useNavigate } from 'react-router-dom'

export interface SufficiencyOfQuantityFooterProps {
  nonCtrlFlg: boolean
  onSaveBtnClick: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
  onTempSaveBtnClick: (
    event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
  ) => void
}

export const SufficiencyOfQuantityFooter: FC<
SufficiencyOfQuantityFooterProps
> = (props) => {
  const navigate = useNavigate()

  /** 戻るボタンをクリック */
  const handleOnGoBackBtnClick = () => {
    navigate(-1)
  }

  return (
    <>
      <div
        className="pcy-search-body-pane-footer pcy-control-box"
        style={{
          backgroundColor: '#FFFFFF'
        }}
      >
        <StackLayout gap={5} align={{ horizontal: 'end' }}>
          <Button onClick={handleOnGoBackBtnClick}>戻る</Button>
          {!props.nonCtrlFlg && (
            <>
              <Button
                onClick={(e) => {
                  props.onTempSaveBtnClick(e)
                }}
                themeColor="primary"
              >
                一時保存
              </Button>
              <Button
                onClick={(e) => {
                  props.onSaveBtnClick(e)
                }}
                themeColor="primary"
              >
                登録
              </Button>
            </>
          )}
        </StackLayout>
      </div>
    </>
  )
}
